import React, { Component } from 'react';
import InputFloating from '../../../../commons/InputFloating';
import ExpDropSelector from '../../../../commons/ExpDropSelector';
import MobLoader from '../../../../commons/MobLoader';
import ErrorBox from '../../../../commons/ErrorBox';
import ImageUploader from '../../../../commons/ImageUploader';
import { sendEventToHevo } from '../../../../utilities/manageEvents.js';

export default class AddNewFreebie extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: '',
            packType: '',
            productTitle: '',
            imagesUrl: {},
            measurementUnit: 'GRAM',
            grammage: '',
            mrp: '',
            barcodeAvailable: '',
            labelCode: '',
            packTypes: ["BAG", "BALL", "BASKET", "BOTTLE", "BOX", "BUCKET", "CAN", "CARTON", "COMBO_PACK", "CONE", "CUP", "GLASS_BOTTLE", "GLASS_JAR", "JAR", "LOOSE", "PACK", "PET_BOTTLE", "PET_JAR", "POUCH", "PUMP", "REFILL_PACK", "ROLL_ON", "SACHET", "SHEET", "SPOUT_POUCH", "STANDUP_POUCH", "STRIP", "TETRA_BRICK", "TETRA_PACK", "TETRA_PACK_POUCH", "TIN", "TRAY", "TUB", "TUBE", "VACUUM_PACK"],
            unitTypes: ["GRAM", "KILOGRAM", "LITRE", "MILLILITRE", "PIECES"],
            vinv: props.location.state.vinv,
            palletId: props.location.state.palletId,
            parentListingId: props.location.state.parentListingId,
            parentListingTitle: props.location.state.parentListingTitle
        }
    }

    getHeader = () => {
        return (
            <div className="header-name-bar" style={{ left: '0' }}>
                <div className="row">
                    <div className="col-xs-1">
                        <div className="visible-xs visible-sm" style={{ lineHeight: '65px', fontSize: '25px' }} onClick={() => { this.props.history.goBack(); }}><i className="fas fa-arrow-left"></i></div>
                    </div>
                    <div className="col-xs-11">
                        <div className="header-page-name">Add New Freebie</div>
                    </div>
                </div>
            </div>
        )
    }

    sendEvent = (eventName, eventData) => {
        const { parentListingId, vinv, palletId } = this.state;
        if (!eventName || !eventData) {
            console.error('data not received');
            return;
        }
        let req = { ...eventData };
        req["parent_listing_id"] = parentListingId ? parentListingId : null;
        req["inwarding_session_id"] = vinv;
        req["gric"] = palletId;
        sendEventToHevo(eventName, req);
    }

    // mapEvents = (name, value) => {
    //     switch (name) {
    //         case 'productTitle':
    //             this.sendEvent('ON_ENTER_FREEBIE_PRODUCT_TITLE', { freebie_product_title: value });
    //             break;
    //         case 'barcodeAvailable':
    //             this.sendEvent('ON_SELECT_FREEBIE_BARCODE', { barcode_available: value });
    //             break;
    //         case 'grammage':
    //             this.sendEvent('ON_ENTER_FREEBIE_GRAMMAGE', { freebie_grammage: Number(value) });
    //             break;
    //         case 'mrp':
    //             this.sendEvent('ON_ENTER_FREEBIE_MRP', { freebie_mrp: Number(value) });
    //             break;
    //         default:
    //             console.error('random case');
    //     }
    // }

    setNameToValue = (e) => {
        const name = e.target.name;
        let val = e.target.value;

        //this.mapEvents(name, val);

        const tar = ['mrp', 'labelCode'];
        if (tar.includes(name) && Number(val) < 0) {
            val = 0;
        }

        this.setState({
            [name]: val
        })
    }

    handleImageUploadResponse = (resp, type) => {
        let imagesUrl = { ...this.state.imagesUrl };
        imagesUrl[type] = resp;
        this.setState({ imagesUrl: imagesUrl });
        // switch (type) {
        //     case 'capturedLabelCodeImageUrl':
        //         this.sendEvent('ON_UPLOAD_FREEBIE_BARCODE', { freebie_barcode_image: resp });
        //         break;
        //     case 'capturedFrontSideImageUrl':
        //         this.sendEvent('ON_UPLOAD_FRONT_BACK_GRAMMAGE_MRP_IMAGE', { freebie_front_image: resp });
        //         break;
        //     case 'backSideImageURL':
        //         this.sendEvent('ON_UPLOAD_FRONT_BACK_GRAMMAGE_MRP_IMAGE', { freebie_back_image: resp });
        //         break;
        //     case 'grammageImageURL':
        //         this.sendEvent('ON_UPLOAD_FRONT_BACK_GRAMMAGE_MRP_IMAGE', { freebie_grammage_image: resp });
        //         break;
        //     case 'mrpImageURL':
        //         this.sendEvent('ON_UPLOAD_FRONT_BACK_GRAMMAGE_MRP_IMAGE', { freebie_mrp_image: resp });
        //         break;
        //     default:
        //         console.error('random case');
        // }
    }

    addFreebieValidation = () => {
        const { productTitle, packType, barcodeAvailable, grammage, mrp, imagesUrl, labelCode } = this.state;

        if (productTitle && productTitle.length > 0 &&
            packType &&
            ((barcodeAvailable === 'no') || (barcodeAvailable === 'yes' && labelCode && imagesUrl.capturedLabelCodeImageUrl)) &&
            grammage && Number(grammage) > 0 &&
            mrp && Number(mrp) > 0 &&
            (imagesUrl.capturedFrontSideImageUrl && imagesUrl.backSideImageURL && imagesUrl.grammageImageURL && imagesUrl.mrpImageURL)
        ) {
            return true;
        }

        return false;
    }

    addFreebieButtonClicked = () => {
        const { productTitle, packType, grammage, measurementUnit, mrp, imagesUrl, labelCode, parentListingId } = this.state;
        let state = {};

        state.mrp = Number(mrp);
        state.productTitle = productTitle;
        state.grammage = Number(grammage);
        state.measurementUnit = measurementUnit;

        state.packType = packType;

        state.labelCode = labelCode ? labelCode : null;
        state.labelCodeMatchStatus = "NOT_IN_PO";
        state.capturedLabelCodeImageUrl = imagesUrl.capturedLabelCodeImageUrl ? imagesUrl.capturedLabelCodeImageUrl : null;

        state.capturedFrontSideImageUrl = imagesUrl.capturedFrontSideImageUrl;
        state.backSideImageURL = imagesUrl.backSideImageURL;
        state.grammageImageURL = imagesUrl.grammageImageURL;
        state.mrpImageURL = imagesUrl.mrpImageURL;

        this.sendEvent('ON_CLICK_ADD_NEW_FREEBIE', {
            mrp: Number(mrp),
            product_title: productTitle,
            grammage: Number(grammage),
            measurement_unit: measurementUnit,
            pack_type: packType,
            front_side_image_url: imagesUrl.capturedFrontSideImageUrl,
            back_side_image_url: imagesUrl.backSideImageURL,
            grammage_image_url: imagesUrl.grammageImageURL,
            mrp_image_url: imagesUrl.mrpImageURL,
            barcode_image: imagesUrl.capturedLabelCodeImageUrl,
            barcode: labelCode
        });

        this.props.history.push({
            pathname: '/Inwarding/FreebieDetails',
            state: {
                freebieType: 'new',
                vinv: this.state.vinv,
                palletId: this.state.palletId,
                parentListingId: this.state.parentListingId,
                parentListingTitle: this.state.parentListingTitle,
                data: state
            }
        });
    }

    addNewFreebieUI = () => {
        const { packType, productTitle, imagesUrl, mrp, measurementUnit, grammage, barcodeAvailable, labelCode, packTypes, unitTypes } = this.state;

        return (
            <div>
                <div className="top-ten">
                    <InputFloating type="text" label="Product Title" name="productTitle" value={productTitle} onChange={this.setNameToValue} />
                </div>
                <div className="top-twenty">
                    <ExpDropSelector options={packTypes} selected={packType} classes={{ drop: 'invoice-type-drop' }} selctionChange={(val) => { this.setState({ packType: val }) }} type={'Pack Type'} />
                </div>

                <div className="top-twenty">
                    <div style={{ fontSize: '15px', color: '#808080' }}>Barcode Available?</div>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '15px' }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', width: '45%' }}>
                            <input type="radio" name="barcodeAvailable" id='barcode1' value='yes' onChange={this.setNameToValue} style={{ marginRight: '5px', visibility: 'hidden' }} />
                            <label htmlFor='barcode1' className={'btn ' + (barcodeAvailable === 'yes' ? 'search-btn-blue' : 'btn-jt-cancel-gr')} style={{ width: '100%', padding: '10px 16px' }} >Yes</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-start', width: '45%' }}>
                            <input type="radio" name="barcodeAvailable" id='barcode2' value='no' onChange={this.setNameToValue} style={{ marginRight: '5px', visibility: 'hidden' }} />
                            <label htmlFor='barcode2' className={'btn ' + (barcodeAvailable === 'no' ? 'search-btn-blue' : 'btn-jt-cancel-gr')} style={{ width: '100%', padding: '10px 16px' }}>No</label>
                        </div>
                    </div>
                </div>

                {(barcodeAvailable === 'yes') ?
                    <div style={{ margin: '20px 40px 0px 40px' }}>
                        <InputFloating type="number" label="Barcode Number" name="labelCode" value={labelCode} onChange={this.setNameToValue} />
                        <div className="top-ten">
                            <div className="image-up-not">Barcode Image</div>
                            {(imagesUrl.capturedLabelCodeImageUrl) ?
                                <div><img src={imagesUrl.capturedLabelCodeImageUrl} alt="Product front" style={{ maxWidth: '100%' }} /></div>
                                :
                                <div><ImageUploader url="inwarding/upload" type="capturedLabelCodeImageUrl" handleUploadResponse={this.handleImageUploadResponse} /></div>
                            }
                        </div>
                    </div>
                    :
                    null
                }

                <div className="top-twenty" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <div style={{ width: '50%' }}><InputFloating type="number" label="Grammage" value={grammage} name='grammage' onChange={this.setNameToValue} /></div>
                    <div style={{ width: '50%' }}><ExpDropSelector type={'Unit'} options={unitTypes} selected={measurementUnit} classes={{ drop: 'invoice-type-drop' }} selctionChange={(val) => { this.setState({ measurementUnit: val }) }} /></div>
                </div>

                <div className="top-twenty justCent">
                    <div className="symbolBox" style={{ width: '15%' }}>₹</div>
                    <div style={{ width: '85%' }}><InputFloating type="number" label="MRP" name="mrp" value={mrp} onChange={this.setNameToValue} /></div>
                </div>

                <div className="top-twenty">
                    <div className="image-up-not">Front Image</div>
                    {(imagesUrl.capturedFrontSideImageUrl) ?
                        <div><img src={imagesUrl.capturedFrontSideImageUrl} alt="Product front" style={{ maxWidth: '100%' }} /></div>
                        :
                        <div><ImageUploader url="inwarding/upload" type="capturedFrontSideImageUrl" handleUploadResponse={this.handleImageUploadResponse} /></div>
                    }
                </div>

                <div className="top-twenty">
                    <div className="image-up-not">Back Image</div>
                    {(imagesUrl.backSideImageURL) ?
                        <div><img src={imagesUrl.backSideImageURL} alt="Product front" style={{ maxWidth: '100%' }} /></div>
                        :
                        <div><ImageUploader url="inwarding/upload" type="backSideImageURL" handleUploadResponse={this.handleImageUploadResponse} /></div>
                    }
                </div>

                <div className="top-twenty">
                    <div className="image-up-not">Grammage Image</div>
                    {(imagesUrl.grammageImageURL) ?
                        <div><img src={imagesUrl.grammageImageURL} alt="Product front" style={{ maxWidth: '100%' }} /></div>
                        :
                        <div><ImageUploader url="inwarding/upload" type="grammageImageURL" handleUploadResponse={this.handleImageUploadResponse} /></div>
                    }
                </div>

                <div className="top-twenty">
                    <div className="image-up-not">MRP Image</div>
                    {(imagesUrl.mrpImageURL) ?
                        <div><img src={imagesUrl.mrpImageURL} alt="Product front" style={{ maxWidth: '100%' }} /></div>
                        :
                        <div><ImageUploader url="inwarding/upload" type="mrpImageURL" handleUploadResponse={this.handleImageUploadResponse} /></div>
                    }
                </div>

                {(this.addFreebieValidation()) ?
                    <div className="bottom-btn" style={{ left: '0', right: '0' }}>
                        <button className="btn btn-big-fin" onClick={this.addFreebieButtonClicked}>Add New Freebie</button>
                    </div> : null
                }
            </div>
        )
    }

    closeError = () => {
        // close error dialog box
        this.setState({ error: '' });
    }

    render() {
        const { loading, error } = this.state;
        return (
            <div style={{ backgroundColor: 'white', padding: '10px', margin: '10px' }} >
                <div className="visible-xs visible-sm">{this.getHeader()}</div>
                {this.addNewFreebieUI()}
                {(loading) ?
                    <MobLoader /> : null
                }
                {(error) ?
                    <ErrorBox errorText={error} closeError={this.closeError} /> : null
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/Inwarding/Components/Commons/AddNewFreebie.js